import React from 'react'
import ReactDOM from 'react-dom'
import singleSpaReact from 'single-spa-react'
import { AppProps as SingleSpaProps } from 'single-spa'
import App from './App'

type LocalStorageUser = { token: string; refreshToken: string }

type StandaloneAppProps = SingleSpaProps & {
  standaloneToken?: {
    refreshToken: string
    bearerToken: string
  }
}

const lifecycles = singleSpaReact({
  React,
  ReactDOM,
  rootComponent: App,
  errorBoundary() {
    return null
  },
  renderType: 'render',
})

export async function bootstrap(props: StandaloneAppProps) {
  if (process.env.standalone && props.standaloneToken) {
    const userToken: LocalStorageUser = {
      token: props.standaloneToken.bearerToken,
      refreshToken: props.standaloneToken.refreshToken,
    }
    localStorage.setItem('@Livia', JSON.stringify(userToken))
  }
  return lifecycles.bootstrap(props)
}

export const { mount, unmount } = lifecycles
